export default class EntityDoesNotExistException extends Error {
  constructor(message: string) {
    super(message);
  }
}
